import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ClientHeader from "../../client-header/components";
import { addClientTicket } from "../slice/clientTicketSlice";
import { toast } from "react-toastify";

const ClientAddTicket = () => {
  const dispatch = useDispatch();
      const navigate = useNavigate();

      const [formData, setFormData] = useState({
              title: "",
              description: "",
              documents: null,
              status: "",
          });
      
          const handleChange = (e) => {
              const { name, value, files } = e.target;
              setFormData((prev) => ({
              ...prev,
              [name]: files ? files[0] : value,
              }));
          };
      
          const handleSubmit = async (e) => {
              e.preventDefault();
      
              if (!formData.status) {
                  toast.error("Please fill status", {
                  position: "top-right",
                  autoClose: 2000,
                  style: { fontSize: "0.85rem" },
                  });
                  return;
              }
      
              if (!formData.title) {
                  toast.error("Please fill title", {
                  position: "top-right",
                  autoClose: 2000,
                  style: { fontSize: "0.85rem" },
                  });
                  return;
              }
        
              const data = new FormData();
              data.append("title", formData.title);
              data.append("description", formData.description);
              data.append("status", formData.status);
              if (formData.documents) {
              data.append("documents", formData.documents);
              }
          
              try {
              const response = await dispatch(addClientTicket(data)).unwrap();
              if (response) {
                  toast.success("Ticket added successfully", {
                  position: "top-right",
                  autoClose: 2000,
                  style: { fontSize: "0.85rem" },
                  });
                  navigate(`/tickets`);
              }
              } catch (error) {
                  toast.error("Failed to add ticket", {
                      position: "top-right",
                      autoClose: 2000,
                      style: { fontSize: "0.85rem" },
                  });
              }
          };
    return (
    <>
      <ClientHeader />
      
      <div className="container mt-4">
                  <form onSubmit={handleSubmit}>
                      <div className="row mb-3">
                          <div className="col-md-6">
                              <label className="form-label">Status <span style={{ color: "red" }}>*</span></label>
                              <select className="form-select" name="status" value={formData.status} onChange={handleChange} aria-label="Default select example">
                                  <option value="" disabled>Please Select</option>
                                  <option value="open">Open</option>
                                  <option value="in_progress">In Progress</option>
                                  <option value="closed">Closed</option>
                              </select>
                          </div>
                          <div className="col-md-6">
                              <label className="form-label">Documents <span style={{ color: "red" }}>*</span></label>
                              <input type="file" name="documents" className="form-control"/>
                          </div>
                      </div>
                      <div className="row mb-3">
                          <div className="col-md-6">
                              <label className="form-label">Title <span style={{ color: "red" }}>*</span></label>
                              <input type="text" name="title" value={formData.title} onChange={handleChange} className="form-control" />
                          </div>
                          <div className="col-md-6">
                              <label className="form-label">Description</label>
                              <textarea name="description" value={formData.description} onChange={handleChange} className="form-control" rows="2" />
                          </div>
                      </div>
                      <button type="submit" className="btn btn-primary">Submit</button>
                      <Link to="/tickets"><button className="btn btn-secondary ms-2">Back</button></Link>
                  </form>
              </div>
    </>
  );
};

export default ClientAddTicket;
